import DownloadList from "../../../components/Lists/DownloadList"
import reportsPageData from "../../../data/arabic/subpages/reports-page-data-ar"
import Footer from "../../../layouts/Footer"
import MainHeader from "../../../layouts/MainHeader"

const ReportsPageAr = () => {
  return (
    <main id="main" className="page">
    <div className="sticky-view-two">
    <div className="sticky-container">
      <MainHeader 
        title=""
        image={{
          src : require(`../../../assets/images/wallpaper/${reportsPageData.header.image.src}`),
          alt : reportsPageData.header.image.alt,
        }}
      />
    </div>
    <div className="sticky-container-two">
      <div className="wrapper-small">
        <h1 className="title-center">{reportsPageData.title}</h1>
        <p className="text-parargraph">{reportsPageData.paragraphOne}</p>
      </div>
      <div className="space-50"></div>
      <div className="space-50"></div>
      <div className="wrapper-small">
        <DownloadList data={[
          {
            name : "SAB ESG Report 2022 (PDF 8 MB)",
            path : './SAB_2022_ESG_report_Arabic_200623.pdf'
          },
          {
            name : "Independent Assurance Report (PDF 400KB)",
            path : "./Final signed Arabic Report.pdf"
          }
        ]} />
      </div>
      <div className="space-50"></div>
      <div className="space-50"></div>
      <Footer withBlogs={false} />
    </div>
    </div>
    </main>
  )
}

export default ReportsPageAr